import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-address-card fs-1 me-4 pt-1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "General Info", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-image fs-1 me-4 pt-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Profile Logo", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar-star fs-1 me-4 pt-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Call Types", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-buildings fs-1 me-4 pt-1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Venues & Rehearsal Spaces", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-address-card fs-1 me-4 pt-1" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Widgets", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right fs-2 pe-4 p-1 ms-auto" }, null, -1)
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('general'))),
      class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
    }, _hoisted_5),
    false
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('logo'))),
          class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
        }, _hoisted_9))
      : _createCommentVNode("", true),
    (!_ctx.isOrganization)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('call-types'))),
          class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
        }, _hoisted_13))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('venues'))),
      class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
    }, _hoisted_17),
    (!_ctx.isOrganization && false)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo('widgets'))),
          class: "d-flex w-100 pt-6 pb-6 border-bottom border-bottom-primary"
        }, _hoisted_21))
      : _createCommentVNode("", true)
  ]))
}